var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Header',{attrs:{"is-auth":_vm.isAuth}}),(_vm.isAuth)?_c('Nav'):_vm._e(),_c('Body'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }